import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed, onMounted } from 'vue'
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'

import NeueLoading from '@/components/neue/NeueLoading.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { AI_AGENTS, useAiAgentSections } from '@/composables/useAgentSections'
import api from '@/store/api'
import { mapRelationship, mapTypeIncludingInactive } from '@/store/mappers'

import { activityConfigFor } from './agentActivity'
import AgentActivityOverview from './AgentActivityOverview.vue'
import { agentLabel, isCateringAgent } from './agentTypes'
import UpsellOverview from './UpsellOverview.vue'


export default {
  __name: 'AgentConversations',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const agentSections = useAiAgentSections()

const findAgent = id => mapTypeIncludingInactive('agent').find(a => a.id === id)

const agent = computed(() => findAgent(route.params.id))
const agentType = computed(() => agent.value?.attributes?.type)

const headerText = computed(() =>
  agent.value ? agentLabel(agent.value, mapRelationship(agent.value.relationships?.agent_playbook?.data)) : ''
)

const load = id =>
  api.call('GET', `agents/${id}?included=agent_playbook`).then(() => {
    if (isCateringAgent(findAgent(id))) router.replace(AI_AGENTS)
  })

onMounted(() => load(route.params.id))

onBeforeRouteUpdate((to, from) => {
  if (to.params.id !== from.params.id) load(to.params.id)
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, {
        text: headerText.value,
        sections: _unref(agentSections)
      }, null, 8, ["text", "sections"])
    ]),
    main: _withCtx(() => [
      _createVNode(NeueLoading, {
        loading: !agent.value
      }, {
        default: _withCtx(() => [
          (agentType.value === 'UpsellAgent')
            ? (_openBlock(), _createBlock(UpsellOverview, {
                key: 0,
                "agent-id": _unref(route).params.id
              }, null, 8, ["agent-id"]))
            : (_unref(activityConfigFor)(agentType.value))
              ? (_openBlock(), _createBlock(AgentActivityOverview, {
                  key: 1,
                  "agent-id": _unref(route).params.id,
                  "agent-type": agentType.value
                }, null, 8, ["agent-id", "agent-type"]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

}